/**
 * PRODUCTION ENVIRONMENT
 */
export default {
	API_KEY: 'AIzaSyAVS6ufV1X6XTd_Kk66APRqsR4ptMx1edo',
	CLIENT_ID: '36050878774-0a5hlkdjh3k4tdhdbgp162p1341npesm.apps.googleusercontent.com',
};
